<template>
  <div class="p_demand_content">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/recruitDemand' }">招聘需求</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_demand_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="岗位信息" name="first"></el-tab-pane>
          <el-tab-pane label="招聘计划" name="second" :disabled="!Id"></el-tab-pane>
        </el-tabs>
        <RecruitInfo ref="child1" v-if="activeName=='first'" :Id="Id" @Id="getId" />
        <div class="p_demands">
          <RecruitPlan ref="child2" v-if="activeName=='second'" :Id="Id" :GdrecpId="GdrecpId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
import RecruitPlan from "./components/recruitPlan.vue";
import RecruitInfo from "./components/recruitInfo.vue"
export default {
  components: {
    RecruitInfo,
    RecruitPlan
  },
  name: "demandUpdate",
  data() {
    return {
      isDetail: false,
      pageTitle: '招聘需求编辑',
      activeName: 'first',
      Id: '',
      GdrecpId: ''
    }
  },
  created() {
    let q = this.$route.query;
    if (q.activeName && q.activeName != undefined) {
      this.activeName = q.activeName;
    }
    if (q.id && q.id != undefined) {
      this.Id = q.id
    }
    if (q.GdrecpId && q.GdrecpId != undefined) {
      this.GdrecpId = q.GdrecpId
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      if(this.Id&&tab.name == 'second'){
        this.childmethod1()
      }else if(this.Id&&tab.name == 'first'){
        this.childmethod2()
      }
    },
    childmethod1(){
      // this.$refs.child1.submitForm();
    },
    childmethod2(){
      // this.$refs.child2.submitSave('待招聘');
    },
    getId(val) {
      if (val.Id != undefined && val.Id && val.GdrecpId != undefined && val.GdrecpId) {
        this.Id = val.Id;
        this.GdrecpId = val.GdrecpId;
      }
      this.activeName = 'second';
    }
  }
}
</script>
<style>
</style>
<style scoped>
.p_demand_box {
  padding: 10px 20px;
  background-color: #fff;
}
</style>